import {combineReducers} from "redux";
import userReducer from "./user.reducer";
import pageReducer from "./page.reducer";

const combinedReducers = combineReducers({
    user: userReducer,
    page: pageReducer
});

export default combinedReducers;